import React from 'react';
import i18n from '@i18n';
import { changeLang, localLang } from './helpers';

const data = [
    { lang: 'sk', className: 'flag-language flag-sk', atid: 'footer-goTo-slovakVersion' },
    { lang: 'en', className: 'flag-language flag-en', atid: 'footer-goTo-englishVersion' },
    { lang: 'hu', className: 'flag-language flag-hu', atid: 'footer-goTo-magyarVersion' }
];

const Languages = () => (
    <div className="link-box language ripple menu-link">
        <div className="lang-bar">
            {localLang && (
                <div className={'flag-language flag-' + localLang}>
                    <span className="lang-name">{i18n('layout.pata.locale.' + localLang)}</span>
                </div>
            )}
            {localLang &&
                data
                    .filter(key => key.lang !== localLang)
                    .map(prop => (
                        <div
                            key={prop.lang}
                            onClick={() => changeLang(prop.lang)}
                            className={prop.className}
                            data-atid={prop.atid}
                        />
                    ))}
        </div>
    </div>
);

export default Languages;
